import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleUnauthorized } from '../../utils/apiHelper';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import './Calendar.css';
import Loader from "./Loder";
import { Link } from 'react-router-dom';

export default function Calendar() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]); // today's date
  const authToken = localStorage.getItem('authToken');
  const navigate = useNavigate();

  useEffect(() => {
    if (date) fetchData();
  }, [date]);

  const fetchData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-dashboard?search-date=${date}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const datas = await response.json();
      setItems(datas.data.bookingListOnDate || []);
    } catch (error) {
      console.error('Fetch error:', error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
const handleDateClick = (info) => {
  const selectedDate = info.dateStr;
  setDate(selectedDate);       // you can keep or remove this line
  fetchData(selectedDate);
};
  return (
    <div className='demo-app'>
      <div className='demo-app-main'>
        <FullCalendar
          height="auto"
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: 'title',
            right: 'prev,next',
          }}
          initialView='dayGridMonth'
          selectable={true}
         dateClick={handleDateClick}
          dayCellClassNames={(arg) => arg.dateStr === date ? 'selected-date' : ''}
          eventContent={() => null} // no events visually
        />
      </div>

      <div className='row mt-20'></div>

      <div className="table-responsive scroll-sm">
        <table className="table bordered-table sm-table mb-0">
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>Amount($)</th>
              <th>Renter Name</th>
              <th>Payment Status</th>
              <th>Booking Status</th>
              <th>Booking Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
            <tr>
                <td colSpan="6" className="text-center">
                <span className="loader-15"></span>
                </td>
            </tr>
            ) : items.length > 0 ? (
            items.slice(0, 5).map((item) => (  // ⬅️ show only first 5
                <tr key={item._id}>
                <td><span className="text-md fw-normal text-secondary-light">{item._id || 'N/A'}</span></td>
                <td><span className="text-md fw-normal text-secondary-light">{item.amount || 'N/A'}</span></td>
                <td><span className="text-md fw-normal text-secondary-light">{(item.renter?.firstName || '') + ' ' + (item.renter?.lastName || '')}</span></td>
                <td>
                    <span className={`${
                    item.paymentStatus === 'succeeded'
                        ? 'text-success-600 border border-success-main'
                        : item.paymentStatus === 'failed'
                        ? 'text-neutral-600 border border-neutral-400'
                        : 'text-warning-600 border border-warning-main'
                    } px-24 py-4 radius-4 fw-medium text-sm`}>
                    {item.paymentStatus?.charAt(0).toUpperCase() + item.paymentStatus?.slice(1)}
                    </span>
                </td>
                <td>
                    <span className={`${
                    item.bookingStatus === 'approved'
                        ? 'text-success-600 border border-success-main'
                        : item.bookingStatus === 'rejected'
                        ? 'text-neutral-600 border border-neutral-400'
                        : 'text-warning-600 border border-warning-main'
                    } px-24 py-4 radius-4 fw-medium text-sm`}>
                    {item.bookingStatus?.charAt(0).toUpperCase() + item.bookingStatus?.slice(1)}
                    </span>
                </td>
                <td>
                    {(() => {
                    const d = new Date(item.startDate);
                    const day = String(d.getDate()).padStart(2, '0');
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const year = d.getFullYear();
                    return `${day}-${month}-${year}`;
                    })()}
                </td>
                </tr>
            ))
            ) : (
            <tr>
                <td colSpan="6" className="text-center">No Data Found</td>
            </tr>
            )}
        </tbody>
        </table>

        {!loading && items.length > 5 && (
            <div className="col-md-1 text-center float-right mt-20" style={{float:'right'}}>
                <Link
                to="/booking"
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 align-items-center gap-2"
                >
                View All
                </Link>
            </div>
        )}

      </div>
    </div>
  );
}
